import type { LoaderFunction } from 'react-router-dom';
import { apiListWrestlerPaged } from '../components/ui_components/ApiList';
import type { Wrestler } from '../types';

// Forma reale della risposta del server (il tipo PaginatedResponse<T> in types/ non corrisponde)
interface RealPageResponse {
    data: {
        data: Wrestler[];
        last_page: number;
        current_page: number;
    };
}

const PER_PAGE = 500;
// Soglia di sicurezza: oltre questo numero di pagine si usa solo server-side
const MAX_PAGES = 20; // = 10.000 wrestler max in client-side mode

export const ListWrestlersResponsiveLoader: LoaderFunction = async () => {
    try {
        // Prima pagina: serve per conoscere last_page
        const firstResponse = (await apiListWrestlerPaged(1, PER_PAGE)) as unknown as RealPageResponse;
        const lastPage: number = firstResponse.data.last_page;
        let allWrestlers: Wrestler[] = [...firstResponse.data.data];

        if (lastPage > MAX_PAGES) {
            // Dataset troppo grande per il client-side: restituisce solo la prima pagina
            console.warn(`Dataset troppo grande (${lastPage} pagine). Modalità client-side disabilitata.`);
            return { data: { data: allWrestlers } };
        }

        // Se ci sono altre pagine le fetchiamo tutte in parallelo
        if (lastPage > 1) {
            const pageNumbers = Array.from({ length: lastPage - 1 }, (_, i) => i + 2);
            const remaining = await Promise.all(
                pageNumbers.map(page => apiListWrestlerPaged(page, PER_PAGE) as unknown as Promise<RealPageResponse>)
            );
            for (const res of remaining) {
                allWrestlers = allWrestlers.concat(res.data.data);
            }
        }

        return { data: { data: allWrestlers } };
    } catch (error) {
        console.error('Loader error:', error);
        throw error; // rilancia l'errore originale invece di mascherarlo
    }
};
